export enum StudentCSVKeys {
  firstName = "First Name",
  lastName = "Last Name",
  email = "Email",
}
